// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"fp-z","breadcrumbForward":"gp-z","breadcrumbBack":"hp-z","selected":"ip-z"};